import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn,
  getHomeRouteForLoggedInUser,
  getUserData,
} from '@/auth/utils'
import reservasRoutes from './reservas.routes'
import faturasRoutes from './faturas.routes'
import assembleiasRoutes from './assembleias.routes'
import muralRoutes from './mural.routes'
import ocorrenciaRoutes from './ocorrencia.routes'
import correspondenciaRoutes from './correspondencia.routes'
import leituraRoutes from './leitura.routes'
import prestacaocontasRoutes from './prestacaocontas.routes'
import telefoneutilRoutes from './telefoneutil.routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...reservasRoutes,
    ...faturasRoutes,
    ...assembleiasRoutes,
    ...muralRoutes,
    ...ocorrenciaRoutes,
    ...correspondenciaRoutes,
    ...leituraRoutes,
    ...prestacaocontasRoutes,
    ...telefoneutilRoutes,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
        resource: 'Home',
        action: 'read',
      },
    },
    {
      path: '/perfil',
      name: 'perfil',
      component: () => import('@/views/conta/Perfil.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Conta',
            active: true,
          },
        ],
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/login',
      name: 'auth-login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/install',
      name: 'install',
      component: () => import('@/views/Install.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/logout',
      name: 'logout',
      redirect: '/login',
      redirectParams: {
        responseCode: 302,
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/error/Error403.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })
    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }
  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
